import { useClonedTracker } from './hooks';
import { XrayPanelContext } from './XrayPanelContext';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const XrayPanelContextProvider = ({
  auth,
  tracker,
  children
}) => {
  const clonedTracker = useClonedTracker(tracker);
  const standaloneTracker = useMemo(() => clonedTracker.clone({
    standalone: true
  }), [clonedTracker]);
  return /*#__PURE__*/_jsx(XrayPanelContext.Provider, {
    value: {
      auth,
      tracker: clonedTracker,
      standaloneTracker
    },
    children: children
  });
};